// extracted by mini-css-extract-plugin
module.exports = {"footer":"style-module--footer--6v-NO","container":"style-module--container--1FOeD","description":"style-module--description--P6bIN"};